import React, { useEffect, useState, useRef, useCallback } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import {
  DocumentDownloadIcon,
  PlusCircleIcon,
} from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Dialog, Transition } from "@headlessui/react";
import ActionDropdown from "../../components/ActionDropdown";
import { Fragment } from "react";
import Paginate from "../../utils/Paginate";
import { convert, formatDate, DisplayTime } from "./../../utils/convertDate";
import DatePicker from "react-date-picker";
import AccountOfficerServices from "../../services/AccountOfficerServices";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import TenantServices from "../../services/TenantServices";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AccountOfficer() {
  const data = {
    bvn: "",
    name: "",
    code: "",
    alternativePhoneNumber: "",
    emailAddress: "",
    phoneNumber: "",
    branchName: "",
    branchAddress: "",
  };

  const [formValue, setFormValue] = useState(data);
  const [accounts, setAccount] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const formatDateToString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };
  const [dateParams, setDateParams] = useState({
    from: "",
    to: "",
  });
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const [editModal, setViewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const listAccountOfficer = useCallback(
    async (page = 1, searchTerm = "", fromParam = "", toParam = "") => {
      setIsSearching(true);
      try {


        const account = await AccountOfficerServices.listAccountOfficer(
          page,
          10,
          searchTerm,
          fromParam,
          toParam
        );

        if (account.data) {
          setAccount([...account.data.result]);
          setPageLength(account.data.result?.length || 0);
          setPageNumber(account.data.totalCount || 0);
          setPageIndex(account.data.pageIndex || 1);
          setPrev(account.data.hasPreviousPage || false);
          setPage(account.data.totalPages || 0);
          setNextPage(account.data.hasNextPage || false);
        }
      } catch (error) {
        console.error("Error fetching accounts:", error);
        fire("error", "Failed to fetch account officers. Please try again.");
      } finally {
        setIsSearching(false);
      }
    },
    []
  );

  // Handle search input
  const handleSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  // Handle search submit
  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    setSearch(searchInput);
    setPageIndex(1);
  };

  const handleDateRange = (e) => {
    e.preventDefault();

    const fromFormatted = formatDateToString(formValues.from);
    const toFormatted = formatDateToString(formValues.to);

    setDateParams({
      from: fromFormatted,
      to: toFormatted,
    });
    setPageIndex(1);
  };

  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };

  //export function
  const handleExport = async () => {
    try {
      const resp = await AccountOfficerServices.exportAccountOfficer(
        search,
        dateParams.from,
        dateParams.to
      );



      if (resp && resp.data) {
        // If the response is a URL, open it
        if (typeof resp.data === "string" && resp.data.startsWith("http")) {
          window.open(resp.data, "_blank");
        } else if (resp.data.url) {
          // If it's an object with a url property
          window.open(resp.data.url, "_blank");
        } else {
          // Try to parse as blob for file download
          const blob = new Blob([resp.data], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "account-officers.csv";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      } else {
        fire("error", "No data returned from export");
      }
    } catch (error) {
      console.error("Error exporting:", error);
      fire("error", `Failed to export: ${error.message}`);
    }
  };

  // comment validation
  const formHandler = {
    nameHandler: (event) => {
      setFormValue({ ...formValue, name: event.target.value });
    },
    bvnHandler: (event) => {
      setFormValue({ ...formValue, bvn: event.target.value });
    },
    codeHandler: (event) => {
      setFormValue({ ...formValue, code: event.target.value });
    },
    altPhoneNumberHandler: (event) => {
      setFormValue({
        ...formValue,
        alternativePhoneNumber: event.target.value,
      });
    },
    emailHandler: (event) => {
      setFormValue({ ...formValue, emailAddress: event.target.value });
    },
    phoneHandler: (event) => {
      setFormValue({ ...formValue, phoneNumber: event.target.value });
    },
    branchNameHandler: (event) => {
      setFormValue({ ...formValue, branchName: event.target.value });
    },
    branchAddressHandler: (event) => {
      setFormValue({ ...formValue, branchAddress: event.target.value });
    },
  };
  const updateOfficer = async (e) => {
    setLoading(true);
    e.preventDefault();
    const resp = await AccountOfficerServices.editAccountOfficer(formValue);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setViewOpen(false);
        listAccountOfficer();
      }, 2000);
      setLoading(false);
    }
  };
  const addOfficer = async (e) => {
    e.preventDefault();
    const create = await AccountOfficerServices.addAccountOfficer(formValue);
    if (create) {
      fire("success", create.message);
      setTimeout(() => {
        setOpen(false);
        listAccountOfficer();
      }, 2000);
    }
  };
  const createOfficer = async () => {
    setOpen(true);
    setFormValue({
      ...formValue,
      bvn: "",
      name: "",
      code: "",
      alternativePhoneNumber: "",
      emailAddress: "",
      phoneNumber: "",
      branchName: "",
      branchAddress: "",
    });
  };
  const handleUpdate = async (e) => {
    setViewOpen(true);
    setFormValue({
      ...formValue,
      bvn: e.bvn,
      name: e.name,
      code: e.code,
      alternativePhoneNumber: e.alternativePhoneNumber,
      emailAddress: e.emailAddress,
      phoneNumber: e.phoneNumber,
      branchName: e.branchName,
      branchAddress: e.branchAddress,
    });
    const resp = await AccountOfficerServices.editAccountOfficer(formValue);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setViewOpen(false);
        window.location.reload();
      }, 2000);
    }
  };
  const deleteOfficer = async (text) => {
    const resp = await AccountOfficerServices.deleteOfficer({
      code: text,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        listAccountOfficer();
      }, 2000);
    }
  };
  const viewAccount = async (code) => {
    window.location.href = `/accounts?code=${code}`;
  };
  const handleClose = async () => {
    setOpen(false);
  };
  const getOrganization = async () => {
    var tenant = sessionStorage.getItem("tenantId");
    const resp = await TenantServices.listTenanat(tenant);
    setBranch([...resp.data.organizationBranches]);
  };

  useEffect(() => {
    listAccountOfficer(pageIndex, search, dateParams.from, dateParams.to);
    getOrganization();
  }, [pageIndex, search, dateParams.from, dateParams.to]);
  return (
    <>
      <Layout title="Account Officer" pageTag={"account"} current={"/officers"}>
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="">
                <div className="sm:flex sm:items-center">
                  <form onSubmit={handleSearchSubmit} className="w-full">
                    <div className="sm:flex-auto flex flex-col lg:flex-row gap-4 items-end">
                      <div className="flex flex-col lg:flex-row gap-4">
                        <div>
                          <p className="text-sm leading-3 text-gray-500">
                            From
                          </p>
                          <div>
                            <DatePicker
                              onChange={dateValidation.fromHandler}
                              value={formValues.from}
                              format="yyyy-MM-dd"
                            />
                          </div>
                        </div>
                        <div>
                          <p className="text-sm leading-3 text-gray-500">To</p>
                          <div>
                            <DatePicker
                              onChange={dateValidation.toHandler}
                              value={formValues.to}
                              format="yyyy-MM-dd"
                            />
                          </div>
                        </div>
                        <div className="mt-5">
                          <button
                            type="button"
                            onClick={handleDateRange}
                            className="hover:text-white active:text-white inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            disabled={isSearching}
                          >
                            {isSearching ? "Applying..." : "Apply Dates"}
                          </button>
                        </div>
                      </div>

                      <div className="flex flex-1 gap-2">
                        <div className="mt-5 relative rounded-md shadow-sm flex-1">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <SearchIcon
                              className="h-5 w-5 text-gray-400"
                              aria-hidden="true"
                            />
                          </div>
                          <input
                            type="text"
                            name="user"
                            id="user"
                            value={searchInput}
                            onChange={handleSearchInput}
                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                            placeholder="Search by name, code, or email"
                          />
                        </div>

                        <div className="mt-5">
                          <button
                            type="submit"
                            className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50"
                            disabled={isSearching}
                          >
                            {isSearching ? "Searching..." : "Search"}
                          </button>
                        </div>

                        <div className="mt-5 flex justify-end gap-2">
                          <button
                            type="button"
                            onClick={handleExport}
                            className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 sm:w-auto"
                            disabled={isSearching}
                          >
                            <DocumentDownloadIcon className="w-4 mr-1.5" />
                            Export CSV
                          </button>

                          <button
                            type="button"
                            onClick={createOfficer}
                            className="inline-flex items-center justify-center rounded-md border border-transparent bg-slate-900 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 sm:w-auto"
                            disabled={isSearching}
                          >
                            <PlusCircleIcon className="w-4 mr-1.5" />
                            Add Officer
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                {isSearching ? (
                  <div className="mt-8 flex justify-center">
                    <HollowDotsSpinner size={40} color="#4D627E" />
                  </div>
                ) : accounts.length === 0 ? (
                  <div className="mt-8 text-center py-12 bg-gray-50 rounded-lg">
                    <p className="text-gray-500">No account officers found</p>
                  </div>
                ) : (
                  <>
                    <div className="mt-8 flex ">
                      <div className="-my-2 w-full overflow-x-auto ">
                        <div className="inline-block min-w-full py-2 align-middle ">
                          <div className="relative ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500"
                                  >
                                    Officer Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Officer BVN
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Officer Code
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Alternative Phone Number
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Email Address
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Phone Number
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Branch Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Branch Address
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Account Opened
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Date Account Created
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Time Created
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                  >
                                    Actions
                                  </th>
                                </tr>
                              </thead>

                              <tbody className="divide-y divide-gray-200 bg-white">
                                {accounts.map((person, i) => (
                                  <tr
                                    key={i}
                                    className="bg-gray-50 hover:bg-gray-100"
                                  >
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.name}{" "}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {" "}
                                      {person.bvn}{" "}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.code}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.alternativePhoneNumber || "-"}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.emailAddress}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.phoneNumber}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.branchName || "-"}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.branchAddress || "-"}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.totalAccountOpen || 0}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {formatDate(person.dateCreated)}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {DisplayTime(person.dateCreated)}
                                    </td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      <ActionDropdown
                                        items={[
                                          { label: "View Account Opened", onClick: () => viewAccount(person.code) },
                                          { label: "Edit Officer", onClick: () => handleUpdate(person) },
                                          { label: "Delete Officer", onClick: () => deleteOfficer(person.code) },
                                        ]}
                                        dropdownWidth="w-40"
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                      nextPage={nextPage}
                      pageIndex={pageIndex}
                      totalCount={pageNumber}
                      totalPages={totalPage}
                      prevPage={prevPage}
                      setPageIndex={setPageIndex}
                    />
                  </>
                )}
              </div>
            </div>
          </main>

          {/* Create modal */}
          <Transition.Root show={open} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Add Officer</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="name"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Enter officer name"
                                    value={formValue.name}
                                    onChange={formHandler.nameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="bvn"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  BVN
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="bvn"
                                    name="bvn"
                                    type="text"
                                    placeholder="Enter officer bvn"
                                    value={formValue.bvn}
                                    onChange={formHandler.bvnHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="emailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Email Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="emailAddress"
                                    name="emailAddress"
                                    type="email"
                                    placeholder="Enter officer email"
                                    value={formValue.emailAddress}
                                    onChange={formHandler.emailHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="code"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Officer Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="code"
                                    name="code"
                                    type="text"
                                    placeholder="Enter officer code"
                                    value={formValue.code}
                                    onChange={formHandler.codeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Phone Number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer phone"
                                    value={formValue.phoneNumber}
                                    onChange={formHandler.phoneHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Alternative Phone number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer alternative phone"
                                    value={formValue.alternativePhoneNumber}
                                    onChange={formHandler.altPhoneNumberHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch name"
                                    id="role"
                                    name="branchName"
                                    onChange={formHandler.branchNameHandler}
                                    value={formValue.branchName}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select branch name"
                                  >
                                    <option value="">
                                      Select branch address
                                    </option>
                                    {branch.map((item, i) => (
                                      <option key={i} value={item.branchName}>
                                        {item.branchName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch address"
                                    id="branchAddress"
                                    name="branchAddress"
                                    onChange={formHandler.branchAddressHandler}
                                    value={formValue.branchAddress}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select branch address"
                                  >
                                    <option value="">
                                      Select branch address
                                    </option>
                                    {branch.map((item, i) => (
                                      <option
                                        key={i}
                                        value={item.branchAddress}
                                      >
                                        {item.branchAddress}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                              onClick={addOfficer}
                            >
                              Add
                            </button>
                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setOpen(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>

          {/* update modal */}
          <Transition.Root show={editModal} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Update Officer</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="name"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Enter officer name"
                                    value={formValue.name}
                                    onChange={formHandler.nameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="bvn"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  BVN
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="bvn"
                                    name="bvn"
                                    type="text"
                                    placeholder="Enter officer bvn"
                                    value={formValue.bvn}
                                    onChange={formHandler.bvnHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="emailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Email Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="emailAddress"
                                    name="emailAddress"
                                    type="email"
                                    placeholder="Enter officer email"
                                    value={formValue.emailAddress}
                                    onChange={formHandler.emailHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="code"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Officer Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="code"
                                    name="code"
                                    type="text"
                                    placeholder="Enter officer code"
                                    disabled={true}
                                    defaultValue={formValue.code}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Phone Number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer phone"
                                    value={formValue.phoneNumber}
                                    onChange={formHandler.phoneHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Alternative Phone number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer alternative phone"
                                    value={formValue.alternativePhoneNumber}
                                    onChange={formHandler.altPhoneNumberHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select role"
                                    id="role"
                                    name="role"
                                    onChange={formHandler.branchNameHandler}
                                    value={formValue.branchName}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select role"
                                  >
                                    <option value="">
                                      {formValue.branchName}
                                    </option>
                                    {branch.map((item, i) => (
                                      <option key={i} value={item.branchName}>
                                        {item.branchName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch address"
                                    id="branchAddress"
                                    name="branchAddress"
                                    onChange={formHandler.branchAddressHandler}
                                    value={formValue.branchAddress}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select role"
                                  >
                                    <option value="">
                                      {formValue.branchAddress}
                                    </option>
                                    {branch.map((item, i) => (
                                      <option
                                        key={i}
                                        value={item.branchAddress}
                                      >
                                        {item.branchAddress}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            {loading === false ? (
                              <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                onClick={updateOfficer}
                              >
                                Update
                              </button>
                            ) : (
                              <HollowDotsSpinner size={40} color="#4D627E" />
                            )}

                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setViewOpen(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </React.Fragment>
      </Layout>
    </>
  );
}
